<script setup>
import { ref, defineProps, defineEmits, computed, onMounted, watch } from 'vue';
import { $api } from '@/services';
import Multiselect from '@suadelabs/vue3-multiselect';
import { useStore } from 'vuex';
import ConfirmSend from '@/views/menu/ConfirmSend.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import { useRouter } from 'vue-router';
import homeIcon from '@/assets/images/icons/home.png';
import spoonIcon from '@/assets/images/icons/spoon-3.png';
import peopleIcon from '@/assets/images/icons/people-fill.png';
import teacherIcon from '@/assets/images/icons/teacher.png';

const targetOptionIcons = {
	all_parents_in_org: homeIcon,
	day_care_class: spoonIcon,
	group_class: peopleIcon,
	custom_parent_of_students: teacherIcon,
};

const store = useStore();
const router = useRouter();
const modalIsOpen = ref(false);
const target = ref(null);
const emit = defineEmits(['close', 'success']);
const id = props.survey?.id;
const props = defineProps({
	survey: {
		type: Object,
		required: true,
	},
});

const boardings = ref([]);
const groups = ref([]);
const students = ref([]);
const selected = ref([]);
const notification = ref({});
const tabs = ref([
	{
		name: 'Chọn đối tượng',
	},
	{
		name: 'Lịch sử gửi Phụ huynh',
	},
]);
const tabSelected = ref(0);
const parentNotificationHistory = ref([]);

onMounted(() => {
	fetchBoardings();
	fetchGroupClasses();
});

watch(target, () => {
	selected.value = [];
});

watch(
	selected,
	() => {
		console.log(selected.value);
	},
	{ deep: true }
);

watch(tabSelected, () => {
	if (tabSelected.value === 1 && id) {
		fetchParentNotificationHistory();
	}
});

async function fetchBoardings() {
	try {
		const res = await $api.boarding.getDayCareClasses();
		boardings.value = res?.data?.data || [];
		students.value = res?.data?.data?.flatMap((item) => item.students);
	} catch (err) {
		console.log(err);
	}
}

async function fetchGroupClasses() {
	try {
		const {
			data: { data },
		} = await $api.groupClasses.list({
			enabled: true,
		});
		groups.value = data;
	} catch (e) {
		store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}

async function fetchParentNotificationHistory() {
	try {
		const res = await $api.survey.getParentNotificationHistory(id);
		parentNotificationHistory.value = res?.data?.data || [];
	} catch (err) {
		console.log(err);
	}
}
const studentOptions = computed(() => {
	return students.value.map((item) => {
		return {
			value: item.id,
			text: item.name,
		};
	});
});

const dayCareOptions = computed(() => {
	return boardings.value.map((item) => {
		return {
			value: item.id,
			text: item.name,
		};
	});
});

const groupClassOptions = computed(() => {
	return groups.value.map((item) => {
		return {
			value: item.id,
			text: item.name,
		};
	});
});
const targetOptions = computed(() => {
	const targetOptions = [
		{
			value: 'all_parents_in_org',
			text: 'PH toàn cơ sở',
		},
		{
			value: 'day_care_class',
			text: 'Lớp bán trú',
		},
		{
			value: 'group_class',
			text: 'Lớp nhóm',
		},
		{
			value: 'custom_parent_of_students',
			text: 'Tuỳ chọn',
		},
	];
	return targetOptions;
});
function submit() {
	let subject = null;
	if (target.value.value === 'custom_parent_of_students') {
		subject = selected.value.map((item) => 'PH bé ' + item.text);
	} else if (target.value.value === 'all_parents_in_org') {
		subject = 'PH toàn cơ sở';
	} else subject = selected.value.map((item) => 'PH lớp ' + item.text);
	notification.value = {
		title: props.survey?.name,
		subject: subject,
		sender: store.state.profile.staff.name,
	};
	modalIsOpen.value = true;
}
async function sendMenuToParent() {
	try {
		modalIsOpen.value = false;

		const payload = {
			notice: '',
		};
		if (!id) {
			payload.survey = props.survey;
			payload.send = true;
		}
		if (target.value.value === 'all_parents_in_org') {
			payload.notice = { subject: 'all_parents_in_org' };
		}
		if (target.value.value === 'custom_parent_of_students') {
			payload.notice = {
				custom_staff_or_student_id_list: selected.value.map(
					(item) => item.value
				),
				subject: 'custom_parent_of_students',
			};
		}
		if (target.value.value === 'day_care_class') {
			payload.notice = {
				day_care_class_id: selected.value.map((item) => item.value),
			};
		}
		if (target.value.value === 'group_class') {
			payload.notice = {
				group_class_id: selected.value.map((item) => item.value),
			};
		}
		console.log(id, 'id');
		if (id) await $api.survey.sendSurveyToParent(id, payload);
		else await $api.survey.sendSurveyWithoutId(payload);
		await store.dispatch('setAlertMessage', {
			message: 'Gửi khảo sát cho phụ huynh thành công',
			type: 'success',
		});
		router.push('/survey');
	} catch (err) {
		modalIsOpen.value = false;
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}

function addStudent(student) {
	if (selected.value.some((item) => item.value === student.value)) {
		return;
	}
	selected.value.push(student);
}
function deleteStudent(student) {
	selected.value = selected.value.filter(
		(item) => item.value !== student.value
	);
}
</script>
<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<ConfirmSend
			@close="modalIsOpen = false"
			@submit="sendMenuToParent"
			:notification="notification"
			:survey="true"
		/>
	</DaModalFrame>
	<div class="fixed inset-y-0 right-0 flex side-over z-50 w-screen md:w-1/2">
		<div
			class="h-full w-full flex flex-col bg-white shadow-xl overflow-y-auto"
		>
			<div class="px-6 py-8 bg-blue-50">
				<div class="flex items-center justify-between gap-1">
					<div class="flex items-center">
						<img
							src="@/assets/images/icons/send.png"
							alt="edit"
							class="w-5 h-5"
						/>
						<div class="text-2xl font-bold text-neutral-700 ml-2">
							Gửi khảo sát cho Phụ huynh
						</div>
					</div>
					<div class="cursor-pointer" @click="emit('close')">
						<svg
							class="h-6 w-6"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
							aria-hidden="true"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M6 18L18 6M6 6l12 12"
							/>
						</svg>
					</div>
				</div>
			</div>
			<div class="w-full mb-10 px-4 sm:px-6 mt-4">
				<div class="border-b border-neutral-200">
					<div
						class="-mb-px flex space-x-8 tabs text-neutral-500"
						aria-label="Tabs"
					>
						<div
							v-for="(tab, index) in tabs"
							:key="index"
							:class="
								tabSelected === index
									? 'border-b-2 text-yellow-700 border-yellow-500'
									: 'text-neutral-400'
							"
							class="border-transparent hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold cursor-pointer"
							@click="tabSelected = index"
						>
							{{ tab.name }}
						</div>
					</div>
				</div>
			</div>
			<div
				class="sideover-content relative flex-1 px-4 sm:px-6"
				style="scroll-behavior: smooth"
				id="slide-over"
			>
				<div v-if="tabSelected === 0">
					<div class="text-neutral-600 font-semibold mb-1">
						Đối tượng*
					</div>
					<Multiselect
						class="target-select"
						track-by="value"
						:searchable="true"
						:allow-empty="false"
						:options="targetOptions"
						v-model="target"
						label="text"
						selectLabel=""
						placeholder="Chọn đối tượng để gửi"
						selectedLabel=""
						deselectLabel="Ấn đễ bỏ chọn"
					>
						<template #option="{ option }">
							<div class="flex items-center gap-2">
								<span
									v-if="targetOptionIcons[option.value]"
									class="target-option-icon shrink-0"
									:style="{
										'--icon-url': `url(${
											targetOptionIcons[option.value]
										})`,
									}"
								/>
								<div
									class="text-neutral-700 text-sm font-normal"
								>
									{{ option.text }}
								</div>
							</div>
						</template>
						<template #noResult> Không tìm thấy kết quả </template>
					</Multiselect>
					<div
						class="w-full mt-6"
						v-if="
							target && ['day_care_class'].includes(target.value)
						"
					>
						<Multiselect
							track-by="value"
							:searchable="true"
							:options="dayCareOptions"
							v-model="targetDayCare"
							label="text"
							selectLabel=""
							placeholder="Chọn phụ huynh của học sinh"
							selectedLabel=""
							deselectLabel="Ấn đễ bỏ chọn"
							@select="addStudent"
						>
							<template #noResult>
								Không tìm thấy kết quả
							</template>
						</Multiselect>
					</div>
					<div
						class="w-full mt-6"
						v-if="target && ['group_class'].includes(target.value)"
					>
						<Multiselect
							track-by="value"
							:searchable="true"
							:options="groupClassOptions"
							label="text"
							selectLabel=""
							placeholder="Chọn lớp nhóm"
							selectedLabel=""
							deselectLabel="Ấn đễ bỏ chọn"
							@select="addStudent"
						>
							<template #noResult>
								Không tìm thấy kết quả
							</template>
						</Multiselect>
					</div>
					<div
						class="w-full mt-6"
						v-if="
							target &&
							['custom_parent_of_students'].includes(target.value)
						"
					>
						<Multiselect
							track-by="value"
							:searchable="true"
							:options="studentOptions"
							label="text"
							selectLabel=""
							placeholder="Chọn phụ huynh của học sinh"
							selectedLabel=""
							deselectLabel="Ấn đễ bỏ chọn"
							@select="addStudent"
						>
							<template #noResult>
								Không tìm thấy kết quả
							</template>
						</Multiselect>
					</div>
					<div v-if="selected.length > 0" class="mt-6">
						<div v-for="student in selected" :key="student.id">
							<div class="flex items-center justify-between mb-2">
								<div>
									Phụ huynh
									{{
										target.value ===
										'custom_parent_of_students'
											? 'bé '
											: 'lớp '
									}}
									<span
										class="font-semibold"
										:class="
											target.value ===
											'custom_parent_of_students'
												? 'text-orange-500'
												: target.value ===
												  'day_care_class'
												? 'text-lime-600'
												: 'text-blue-600'
										"
										>{{ student.text }}</span
									>
								</div>
								<div
									class="flex items-center gap-1 cursor-pointer"
								>
									<img
										src="@/assets/images/icons/trash-fill-blue.png"
										alt="close"
										class="w-4 h-4"
									/>
									<div
										class="text-blue-600 font-semibold text-sm"
										@click="deleteStudent(student)"
									>
										Xoá
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="tabSelected === 1">
					<div class="overflow-hidden w-full shadow-sm rounded-lg">
						<table class="divide-y text-neutral-200 w-full">
							<thead class="bg-neutral-100 h-16">
								<tr>
									<th
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										scope="col"
									>
										Ngày gửi
									</th>
									<th
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										scope="col"
									>
										Đối tượng
									</th>
									<th
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										scope="col"
									>
										PH đã xem
									</th>
									<th
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										scope="col"
									>
										Người gửi
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="item in parentNotificationHistory"
									:key="item.id"
									class="bg-white text-neutral-700 border-t"
								>
									<td
										class="p-4 text-neutral-700"
										style="max-width: 125px"
									>
										{{
											item.sent_at
												.replace('T', ' ')
												.replace('Z', '')
										}}
									</td>
									<td
										class="p-4 whitespace-nowrap text-neutral-700"
										v-html="item.display_subject.replace(/\n/g, '<br/>')"
									></td>
									<td
										class="p-4 whitespace-nowrap text-neutral-700"
									>
										{{ item.view_count }} /
										{{ item.total_parent_received }}
									</td>
									<td
										class="p-4 whitespace-nowrap text-neutral-700"
									>
										<div class="flex items-center">
											<div class="flex-shrink-0">
												<img
													class="shadow-sm inline-block h-6 w-6 rounded-full"
													:src="
														item?.sent_by_staff
															?.profile_photo
															?.w200
													"
													alt=""
													v-if="
														item?.sent_by_staff
															?.profile_photo
															?.w200
													"
												/>
												<span
													v-else
													class="inline-flex items-center justify-center h-6 w-6 rounded-full"
													:style="{
														background:
															item?.sent_by_staff
																?.profile_photo
																?.default
																?.color,
													}"
												>
													<span
														class="font-medium leading-none text-white text-xs"
														>{{
															item?.sent_by_staff
																?.profile_photo
																?.default
																?.initial
														}}</span
													>
												</span>
											</div>
											<div
												class="ml-2 text-blue-600 font-semibold whitespace-nowrap flex-1"
											>
												{{
													item?.sent_by_staff
														.full_name
												}}
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div
				class="px-6 py-4 border-t border-yellow-50"
				v-if="tabSelected === 0"
			>
				<div class="flex justify-end">
					<div>
						<button
							type="button"
							class="button-p text-center w-32"
							@click="submit"
						>
							Xác nhận
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.target-option-icon {
	width: 1rem;
	height: 1rem;
	display: inline-block;
	background-color: #a3a3a3;
	-webkit-mask: var(--icon-url) no-repeat center / contain;
	mask: var(--icon-url) no-repeat center / contain;
}

:deep(.target-select .multiselect__option--highlight .target-option-icon) {
	background-color: #344256;
}
</style>